export default __webpack_public_path__ + "static/media/santa_snowdown_1.a2412288.png";